import React, { useEffect } from "react";
import HeroBanner from "../../components/DynamicHero";
import Intro from "../../components/playgrounds/Intro";
import Offers from "../../components/playgrounds/Offers";
import EshopPlayground from "../../components/playgrounds/EshopPlayground";
import { setMetaTag, setPropertyMetaTag } from "../../helpers/seoUtils";
import { useTranslation } from "react-i18next";

const PlaygroundPage = () => {
  const { t } = useTranslation();
  useEffect(() => {
    document.title = "Children’s Playgrounds in Lithuania – Economus";

    setMetaTag(
      "description",
      "Discover high-quality, certified children’s playgrounds in Lithuania by Economus. Safe, durable, and engaging for all ages."
    );
    setMetaTag(
      "keywords",
      "playgrounds, playgrounds in Lithuania, Economus, Children’s playgrounds, vaikų žaidimų aikštelės"
    );
    setMetaTag("robots", "index, follow");
    setMetaTag("twitter:card", "summary_large_image");
    setMetaTag(
      "twitter:title",
      "Children’s Playgrounds in Lithuania – Economus"
    );
    setMetaTag(
      "twitter:description",
      "Explore modern and safe children’s playgrounds built for communities across Lithuania."
    );
    setMetaTag(
      "twitter:image",
      "https://economus.netlify.app/static/media/work-completed6.793030f256421f54f0eb.webp"
    );
    setMetaTag("language", "lt");
    setMetaTag("geo.region", "LT");
    setMetaTag("geo.placename", "Lithuania");

    setPropertyMetaTag(
      "og:title",
      "Children’s Playgrounds in Lithuania – Economus"
    );
    setPropertyMetaTag(
      "og:description",
      "From design to installation – premium playgrounds across Lithuania for schools, parks, and neighborhoods."
    );
    setPropertyMetaTag(
      "og:image",
      "https://economus.netlify.app/static/media/work-completed6.793030f256421f54f0eb.webp"
    );
    setPropertyMetaTag("og:url", "https://economus.netlify.app/playgrounds");
    setPropertyMetaTag("og:type", "website");
  }, []);

  return (
    <>
      <HeroBanner text={t("navTranslate.playgrounds")} />
      <Intro />
      <Offers />
      <EshopPlayground />
    </>
  );
};

export default PlaygroundPage;
